export var classListSupport = 'classList' in document.createElement('_');


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/classListSupport.js
// module id = 837
// module chunks = 2